import React, {useEffect, useState} from "react";
import { useHistory, useParams } from "react-router-dom";
import $ from "jquery";
import moment from "moment";
import usePrevious from "../../../../class/tool/usePrevious";
import LoaderCircle from "../../../loader/LoaderCircle";
import CancelIcon from "../../../icons/CancelIcon";
import AutomaticDrawerController from "../../../../stories/_setting/AutomaticDrawers/AutomaticDrawerController";
import "../../../../css/page/content/automaticdrawer/DrawerHistory.css";
import denom1 from "../../../../image/ressource/money/1.png";
import denom2 from "../../../../image/ressource/money/2.png";
import denom5 from "../../../../image/ressource/money/5.png";
import denom10 from "../../../../image/ressource/money/10.png";
import denom20 from "../../../../image/ressource/money/20.png";
import denom50 from "../../../../image/ressource/money/50.png";
import denom100 from "../../../../image/ressource/money/100.png";
import denom200 from "../../../../image/ressource/money/200.png";
import denom500 from "../../../../image/ressource/money/500.png";
import denom1000 from "../../../../image/ressource/money/1000.png";
import denom2000 from "../../../../image/ressource/money/2000.png";
import denom5000 from "../../../../image/ressource/money/5000.png";
import denom10000 from "../../../../image/ressource/money/10000.png";
import denom20000 from "../../../../image/ressource/money/20000.png";
import denom50000 from "../../../../image/ressource/money/50000.png";
import "moment/locale/fr";
moment.locale('fr');

const DrawerHistory = () => {
    const [drawer, setDrawer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [drawerStatus, setDrawerStatus] = useState(null);
    const [intervalEvents, setIntervalEvents] = useState(null);
    const [lastEvents, setLastEvents] = useState([]);
    const [lastInventory, setLastInventory] = useState(null);
    const [amountStacker, setAmountStacker] = useState(null);
    const [amountCassette, setAmountCassette] = useState(null);
    const [amountTotal, setAmountTotal] = useState(null);
    const [qty1, setQty1] = useState(null);
    const [qty2, setQty2] = useState(null);
    const [qty5, setQty5] = useState(null);
    const [qty10, setQty10] = useState(null);
    const [qty20, setQty20] = useState(null);
    const [qty50, setQty50] = useState(null);
    const [qty100, setQty100] = useState(null);
    const [qty200, setQty200] = useState(null);
    const [qty500, setQty500] = useState(null);
    const [qty1000, setQty1000] = useState(null);
    const [qty2000, setQty2000] = useState(null);
    const [qty5000, setQty5000] = useState(null);
    const [qty10000, setQty10000] = useState(null);
    const [qty20000, setQty20000] = useState(null);
    const [qty50000, setQty50000] = useState(null);
    const [selected, setSelected] = useState("stacker");
    const prevAmountStacker = usePrevious(amountStacker);
    const prevAmountCassette = usePrevious(amountCassette);
    const prevAmountTotal = usePrevious(amountTotal);
    const prevQty1 = usePrevious(qty1);
    const prevQty2 = usePrevious(qty2);
    const prevQty5 = usePrevious(qty5);
    const prevQty10 = usePrevious(qty10);
    const prevQty20 = usePrevious(qty20);
    const prevQty50 = usePrevious(qty50);
    const prevQty100 = usePrevious(qty100);
    const prevQty200 = usePrevious(qty200);
    const prevQty500 = usePrevious(qty500);
    const prevQty1000 = usePrevious(qty1000);
    const prevQty2000 = usePrevious(qty2000);
    const prevQty5000 = usePrevious(qty5000);
    const prevQty10000 = usePrevious(qty10000);
    const prevQty20000 = usePrevious(qty20000);
    const prevQty50000 = usePrevious(qty50000);
    const urlParams = useParams();
    const history = useHistory();
    const textStatus = {
        "ON": "Connecté",
        "OFF": "Déconnecté",
        "ERROR": "Erreur"
    };
    const LOG = false;
    const INTERVAL_GET = 30000;
    const EVOL_PERCENT = 15;

    const close = () => {
        history.goBack();
    }
    const clearIntervals = () => {
        if (intervalEvents !== null)
            clearInterval(intervalEvents);
    }
    const getDrawer = () => {
        const controller = new AutomaticDrawerController();
        controller._callback = returnGetDrawer;
        controller.show(urlParams.id);
    }
    const returnGetDrawer = (obj, error, status) => {
        setLoading(false);

        switch (status) {
            case 200: setDrawer(obj); break;
            default: break;
        }
    }
    const getLastEvents = init => {
        if (drawer === null) return;
        drawer.getEvents(returnGetLastEvents, null, 25);

        if (init) {
            const interval = setInterval(() => { getLastEvents(false); }, INTERVAL_GET);
            setIntervalEvents(interval);
        }
    }
    const returnGetLastEvents = (list, error, status) => {
        switch (status) {
            case 200:
                setLastEvents(list);
                break;
            default:
                console.error("LAST-EVENTS-" + drawer.id, list, error, status);
                break;
        }
    }
    const getLastInventory = () => {
        if (drawer === null) return;
        drawer.getEvents(returnGetLastInventory, ["15"], 1);
    }
    const returnGetLastInventory = (list, error, status) => {
        switch (status) {
            case 200:
                if (list.length > 0)
                    setLastInventory(list[0]);

                break;
            default:
                console.error("LAST-INVENTORY-" + drawer.id, list, error, status);
                break;
        }
    }
    const checkLastEvents = () => {
        if (lastEvents === null || lastEvents.length === 0)
            return;

        let events = lastEvents.slice();
        let inventoryUpdated = false;
        let statusUpdated = false;

        events.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        for (let i in events) {
            let event = events[i];

            if (["10", "11", "12", "15"].includes(event.identifier) && !inventoryUpdated) {
                inventoryUpdated = true;
                explodeInventory(event.response);
            }

            if (["120", "121", "122"].includes(event.identifier) && !statusUpdated) {
                statusUpdated = true;
                explodeStatus(event.identifier);
            }
        }
    }
    const explodeStatus = identifier => {
        const status = {
            "122": "ON",
            "121": "OFF",
            "120": "ERROR"
        };

        setDrawerStatus(status[identifier]);
    }
    const explodeInventory = response => {
        if (response === null)
            return;

        const inventory = drawer.explodeInventory(JSON.parse(response));

        try {
            setAmountStacker(inventory["stacker"]["total"]);
            setAmountCassette(inventory["cassette"]["total"]);
            setAmountTotal(inventory["total"]["total"]);
        }
        catch (e) {}

        updateInventory(inventory);
    }
    const updateInventory = inventory => {
        if (inventory === undefined || inventory === null) {
            if (lastInventory === null) return;

            inventory = drawer.explodeInventory(JSON.parse(lastInventory.response));
        }

        try {
            if (inventory[selected] !== undefined && inventory[selected]["1"] !== undefined && inventory[selected]["1"]["piece"] !== undefined)
                setQty1(inventory[selected]["1"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["2"] !== undefined && inventory[selected]["2"]["piece"] !== undefined)
                setQty2(inventory[selected]["2"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["5"] !== undefined && inventory[selected]["5"]["piece"] !== undefined)
                setQty5(inventory[selected]["5"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["10"] !== undefined && inventory[selected]["10"]["piece"] !== undefined)
                setQty10(inventory[selected]["10"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["20"] !== undefined && inventory[selected]["20"]["piece"] !== undefined)
                setQty20(inventory[selected]["20"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["50"] !== undefined && inventory[selected]["50"]["piece"] !== undefined)
                setQty50(inventory[selected]["50"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["100"] !== undefined && inventory[selected]["100"]["piece"] !== undefined)
                setQty100(inventory[selected]["100"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["200"] !== undefined && inventory[selected]["200"]["piece"] !== undefined)
                setQty200(inventory[selected]["200"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["500"] !== undefined && inventory[selected]["500"]["piece"] !== undefined)
                setQty500(inventory[selected]["500"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["1000"] !== undefined && inventory[selected]["1000"]["piece"] !== undefined)
                setQty1000(inventory[selected]["1000"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["2000"] !== undefined && inventory[selected]["2000"]["piece"] !== undefined)
                setQty2000(inventory[selected]["2000"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["5000"] !== undefined && inventory[selected]["5000"]["piece"] !== undefined)
                setQty5000(inventory[selected]["5000"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["10000"] !== undefined && inventory[selected]["10000"]["piece"] !== undefined)
                setQty10000(inventory[selected]["10000"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["20000"] !== undefined && inventory[selected]["20000"]["piece"] !== undefined)
                setQty20000(inventory[selected]["20000"]["piece"]);
            if (inventory[selected] !== undefined && inventory[selected]["50000"] !== undefined && inventory[selected]["50000"]["piece"] !== undefined)
                setQty50000(inventory[selected]["50000"]["piece"]);
        }
        catch (e) {
            console.error(e);
        }
    }
    const controlNumbers = () => {
        evolDecimal("historyAmountStacker", amountStacker, prevAmountStacker);
        evolDecimal("historyAmountCassette", amountCassette, prevAmountCassette);
        evolDecimal("historyAmountTotal", amountTotal, prevAmountTotal);
        evolInteger("denom1", qty1, prevQty1);
        evolInteger("denom2", qty2, prevQty2);
        evolInteger("denom5", qty5, prevQty5);
        evolInteger("denom10", qty10, prevQty10);
        evolInteger("denom20", qty20, prevQty20);
        evolInteger("denom50", qty50, prevQty50);
        evolInteger("denom100", qty100, prevQty100);
        evolInteger("denom200", qty200, prevQty200);
        evolInteger("denom500", qty500, prevQty500);
        evolInteger("denom1000", qty1000, prevQty1000);
        evolInteger("denom2000", qty2000, prevQty2000);
        evolInteger("denom5000", qty5000, prevQty5000);
        evolInteger("denom10000", qty10000, prevQty10000);
        evolInteger("denom20000", qty20000, prevQty20000);
        evolInteger("denom50000", qty50000, prevQty50000);
    }
    const evolDecimal = (id, value, prevValue) => {
        let prev, delta, step, loop;

        if (value !== null && prevValue !== undefined && parseFloat(value) !== parseFloat(prevValue)) {
            try {
                loop = 1;
                prev = prevValue !== null ? prevValue : 0;
                delta = Math.abs(Math.round((parseFloat(value) - parseFloat(prev)) * 100) / 100);
                step = Math.round(((EVOL_PERCENT * delta) / 100) * 100) / 100;

                if (LOG) console.log(id, value, prev, delta, step);
                if (Math.abs(delta) === 0) return;

                if (parseFloat(value) >= parseFloat(prev)) {
                    for (let i = parseFloat(prev); i <= parseFloat(value); i = Math.round((i + step) * 100) / 100) {
                        if (i > parseFloat(value))
                            i = parseFloat(value);

                        setTimeout(() => { $("#" + id + " > strong").text(new Intl.NumberFormat("de-DE", {minimumFractionDigits: 2}).format(i)); }, loop*100);

                        loop++;
                    }

                }
                else {
                    for (let i = parseFloat(prev); i <= parseFloat(value); i = Math.round((i - step) * 100) / 100) {
                        if (i < parseFloat(value))
                            i = parseFloat(value);

                        setTimeout(() => { $("#" + id + " > strong").text(new Intl.NumberFormat("de-DE", {minimumFractionDigits: 2}).format(i)); }, loop*100);

                        loop++;
                    }
                }

                setTimeout(() => { $("#" + id + " > .value").text(new Intl.NumberFormat("de-DE", {minimumFractionDigits: 2}).format(parseFloat(value))); }, loop*100);
            }
            catch (error) {}
        }
    }
    const evolInteger = (id, value, prevValue) => {
        let prev, delta, step, loop;

        if (value !== null && prevValue !== undefined && parseInt(value) !== parseInt(prevValue)) {
            try {
                loop = 1;
                prev = prevValue !== null ? prevValue : 0;
                delta = Math.abs(parseInt(value) - parseInt(prev));
                step = delta > 1 ? Math.round(((EVOL_PERCENT * delta) / 100)) : 1;

                if (delta > 0 && step === 0)
                    step = 1;

                if (Math.abs(delta) === 0) return;

                if (parseInt(value) >= parseInt(prev)) {
                    for (let i = parseInt(prev); i <= parseInt(value); i = i + step) {
                        if (i > parseInt(value))
                            i = parseInt(value);

                        setTimeout(() => { $("#" + id + " > strong").text(i); }, loop*100);

                        loop++;
                    }
                }
                else {
                    for (let i = parseInt(prev); i <= parseInt(value); i = i - step) {
                        if (i < parseInt(value))
                            i = parseInt(value);

                        setTimeout(() => { $("#" + id + " > strong").text(i); }, loop*100);

                        loop++;
                    }
                }

                setTimeout(() => { $("#" + id + " > strong").text(parseInt(value)); }, loop*100);
            }
            catch (error) {}
        }
    }

    useEffect(() => {
        getDrawer();
    }, []);
    useEffect(() => {
        return() => {
            clearIntervals();
        }
    }, [intervalEvents]);
    useEffect(() => {
        if (drawer !== null) {
            setDrawerStatus(drawer.status);
            getLastInventory();
            getLastEvents(true);
        }
    }, [drawer]);
    useEffect(() => {
        if (lastInventory !== null)
            explodeInventory(lastInventory.response);
    }, [lastInventory]);
    useEffect(() => {
        checkLastEvents();
    }, [lastEvents]);
    useEffect(() => {
        controlNumbers();
    }, [amountStacker, amountCassette, amountTotal, qty1, qty2, qty5, qty10, qty20, qty50, qty100, qty200, qty500, qty1000, qty2000, qty5000, qty10000, qty20000, qty50000]);
    useEffect(() => {
        updateInventory();
    }, [selected]);

    return (
        <div className="overlayer">
            <div className="wrapOverbox">
                <div className="overbox drawerHistory">
                    <div className={"head"}>
                        <div className={"containerTitleBox"}>
                            <div className={"titleBox"}>
                                <p className={"title"}>{(drawer !== null ? drawer.name : "")}</p>
                                <p className={"subTitle"}>{(lastEvents.length > 0 ? moment.utc(lastEvents[0].created_at).local().fromNow() : "")}</p>
                            </div>
                            {
                                drawerStatus !== null && <p className={"state " + drawerStatus}>{textStatus[drawerStatus]}</p>
                            }
                        </div>
                        <div className={"close"} onClick={close}>
                            <CancelIcon />
                            <p>Fermer</p>
                        </div>
                    </div>
                    {
                        (
                            loading
                                ? <div className="wrapCenterLoader">
                                    <LoaderCircle display="loader restGETInForm" strokeWidth="8" />
                                </div>
                                : <div className="wrapForm">
                                    <div className={"inventory"}>
                                        <div className={"column"}>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom500"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image"} src={denom500} alt={"5 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom1000"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image"} src={denom1000} alt={"10 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom2000"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image"} src={denom2000} alt={"20 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom5000"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image"} src={denom5000} alt={"50 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom10000"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image"} src={denom10000} alt={"100 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom20000"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image"} src={denom20000} alt={"200 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom50000"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image"} src={denom50000} alt={"500 €"} />
                                            </div>
                                        </div>
                                        <div className={"column"}>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom200"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image piece"} src={denom200} alt={"2 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom100"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image piece"} src={denom100} alt={"1 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom50"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image piece"} src={denom50} alt={"0,50 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom20"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image piece"} src={denom20} alt={"0,20 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom10"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image piece"} src={denom10} alt={"0,10 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom5"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image piece"} src={denom5} alt={"0,05 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom2"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image piece"} src={denom2} alt={"0,02 €"} />
                                            </div>
                                            <div className={"denomination"}>
                                                <p className={"qty"} id={"denom1"}><strong>0</strong></p>
                                                <p className={"multiplier"}>x</p>
                                                <img className={"image piece"} src={denom1} alt={"0,01 €"} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"displayer"}>
                                        <div className={"part" + (selected === "stacker" ? " selected": "")} id={"historyAmountStacker"} onClick={() => { setSelected("stacker"); }}>
                                            <p className={"text"}>Recyclant</p>
                                            <p className={"value"}>0,00</p>
                                        </div>
                                        <div className={"part center" + (selected === "cassette" ? " selected": "")} id={"historyAmountCassette"} onClick={() => { setSelected("cassette"); }}>
                                            <p className={"text"}>Cassette</p>
                                            <p className={"value"}>0,00</p>
                                        </div>
                                        <div className={"part right" + (selected === "total" ? " selected": "")} id={"historyAmountTotal"} onClick={() => { setSelected("total"); }}>
                                            <p className={"text"}>Total</p>
                                            <p className={"value"}>0,00</p>
                                        </div>
                                    </div>
                                </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default DrawerHistory;
